module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Sports/color/inactive/football-fe4f3a62523062a321668cd16d87b8ee.svg";